export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.7-0959.43",
  commitId: "849d2fc419ceec0108a3926c43c6fdb3f10d8f0c",
  commitTime: "2026-07-07T09:59:43.000Z",
});
